<template>
  <transition name="slide-down" mode="out-in">
    <div class="flex justify-center items-center h-screen">
      <div class="flex-col">
        <img v-if="qrCode" :src="'data:image/png;base64,' + qrCode" alt="QR Code" />
        <p class="my-6 mx-auto">
          scan this using google authenticator, duo, or your favorite totp mobile app
        </p>
        <ErrorMessage v-if="errorMessage" :error="errorMessage" class="mb-4" />
        <Button v-if="errorMessage" type="primary" :inFlight="isLoading"
                @onClick="loadEnrollment">
          Try Again
        </Button>
        <Button v-else type="primary" class="text-gray-300" :disabled="!qrCode"
                :inFlight="isLoading" @onClick="nextStage">
          Continue
        </Button>
        <router-link :to="{ name: 'login' }" class="block mt-4 text-sm text-gray-200">
          Back to Login
        </router-link>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from 'vuex';
import Button from '@/components/Button.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

export default {
  name: 'TotpEnroll',
  components: { Button, ErrorMessage },
  mounted() {
    this.loadEnrollment();
  },
  data() {
    return {
      qrCode: '',
      isLoading: false,
      errorMessage: '',
      isActive: true,
    };
  },
  beforeDestroy() {
    this.isActive = false;
  },
  methods: {
    ...mapActions(['totpEnroll']),
    async loadEnrollment() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.errorMessage = '';
      try {
        const { data } = await this.totpEnroll();
        if (!this.isActive) return;
        if (!data || !data.qrCode) throw new Error('Missing enrollment code');
        this.qrCode = data.qrCode;
        localStorage.setItem('new-account', 'true');
      } catch (error) {
        if (!this.isActive) return;
        if (error.response && error.response.status === 401) {
          await this.$router.replace({ name: 'login' });
        } else {
          this.errorMessage = 'Unable to load setup. Please try again.';
        }
      } finally {
        this.isLoading = false;
      }
    },
    nextStage() {
      this.$router.push('/totp-verify');
    },
  },
};
</script>

<style scoped></style>
